export const HEADERS = {
  'Access-Control-Allow-Origin': '*',
}

// auth
export const API_ROUTES_GET_VEHICLE_MODELS = 'api/v1/rgs/export/car-models'
export const API_ROUTES_CHECK_DOCUMENTS = '/api/v1/rgs/complex-documents/send'

// office
export const API_ROUTES_GET_REGIONS = '/api/v1/rgs/export/regions'
export const API_ROUTES_GET_CITIES = '/api/v1/rgs/other/cities'
export const API_ROUTES_GET_OFFICES = '/api/v1/rgs/export/offices'
export const API_ROUTES_GET_OFFICES_BY_BOUNDS = '/api/v1/rgs/export/offices'
export const API_ROUTES_GET_AGENTS_BY_BOUNDS = '/api/v1/rgs/export/agents-map'
export const API_ROUTES_GET_STOAS = '/api/v1/rgs/stoa/list'
export const API_ROUTES_GET_INSURANCE_PERIODS =
  '/api/v1/rgs/other/opo-accidients'
export const API_ROUTES_CHECK_STATUS = '/api/v1/rgs/claim/status'
export const API_ROUTES_CHECK_AGENT = '/api/v1/rgs/export/brokers-agents'
export const API_ROUTES_CHECK_BSO = '/api/v1/rgs/bso/check'
export const API_ROUTES_SEND_APPEAL = '/api/v2/rgs/appeal/request'
export const API_ROUTES_SEND_CERTIFICATE_PAYMENT = '/api/v2/rgs/appeal/request'
export const API_ROUTES_SEND_FEEDBACK = '/api/v1/rgs/appeal/feedback-form'
export const API_ROUTES_SEND_FOREIGN = '/api/v1/rgs/appeal/foreigner-form'
export const API_ROUTES_SEND_MORTGAGE_APPEAL =
  '/api/v1/rgs/appeal/mortgage-form'

export const API_ROUTES_SEND_SPORT_INSURANCE_CASE =
  '/api/v1/rgs/form/insurance-case'
export const API_ROUTES_DOWNLOAD_AGENTS = '/xls/download/agents-brokers'
export const API_ROUTES_GET_APPEAL = '/api/v1/rgs/appeal/request-info'
export const API_ROUTES_SEND_DEBTOR = '/api/v1/rgs/debtor/send'
export const API_ROUTES_SEND_SMS = '/api/v1/rgs/sms/send'
export const API_ROUTES_SEND_CONFIRM_EMAIL_APPEAL =
  '/api/v1/rgs/appeal/email-confirmation'

// insurance
export const API_ROUTES_REGISTER_CLAIM = '/api/v1/rgs/claim/create'
// feedback agents
export const API_ROUTES_FEEDBACK_AGENTS =
  '/api/v1/rgs/form/preferential-insurance'
export const API_SEARCH_BOT_SEARCHING = '/api/v1/rgs/search/'
export const API_SEARCH_BOT_AUTOCOMPLETE = '/api/v1/rgs/search/helpers/'
export const API_SEARCH_NEXT_QUESTION = '/api/v1/rgs/search/question/'

export const API_SEARCH_BOT_START = '/api/v1/rgs/nano/startDialog'
export const API_SEARCH_BOT_RESTART = '/api/v1/rgs/nano/restartDialog'
export const API_SEARCH_BOT_EVENT = '/api/v1/rgs/nano/sendEvent'
export const API_SEARCH_BOT_SEND = '/api/v1/rgs/nano/sendRequest'
export const API_SEARCH_BOT_GET = '/api/v1/rgs/nano/getResponse'
export const API_SEARCH_BOT_RATE = '/api/v1/rgs/nano/rateResponse'

export const GET_PHONE_VERIFICATION_CODE = '/api/v1/rgs/form/send-code'
export const SEND_PHONE_VERIFICATION_CODE = '/api/v1/rgs/form/verify-code'
export const GET_FEEDBACK_SELECT_LISTS = '/api/v1/rgs/form/customer-request'

export const API_ROUTES_SEND_TO_AGENT = '/api/v1/rgs/agents/send'

// ships policy
export const API_ROUTES_SHIP_POLICY_SEARCH = '/api/v1/rgs/ships/checkInsurance'

export const API_ROUTES_APPEAL_LOG_APPLICATION =
  '/api/v1/rgs/appeal/log-application'

export const API_GET_EMAIL_VERIFICATION_CODE =
  '/api/v1/rgs/form/verification/send-email'
export const API_SEND_EMAIL_VERIFICATION_CODE =
  '/api/v1/rgs/form/verification/verify-email'

export const API_LOG_MARKETING_AGREEMENT = '/api/v1/rgs/form/send-for-log'

export const API_ROUTES_CHECK_RESOLUTE_GOS_NUM =
  '/api/v1/rgs/resolute/e-osago/check-gos-number'

export const API_ROUTES_BECOME_AGENT = '/api/v1/rgs/form/become-agent'

export const API_ROUTES_GET_CLINICS_BY_BOUNDS = '/api/v1/rgs/mite/offices'

export const API_ROUTES_KASKO_SEARCH = '/api/v1/rgs/prolongation/kasko/search'
export const API_ROUTES_KASKO_PAYMENT_CREATE =
  '/api/v1/rgs/prolongation/kasko/paymentCreate'
export const API_ROUTES_KASKO_PAYMENT_STATUS =
  '/api/v1/rgs/prolongation/kasko/getStatus'
export const API_ROUTES_KASKO_DOCUMENTS =
  '/api/v1/rgs/prolongation/kasko/printout'
export const API_ROUTES_KASKO_EMAIL_UPDATE =
  '/api/v1/rgs/prolongation/kasko/emailUpdate'

export const API_ROUTES_SERVICE_FORM = '/api/v1/rgs/service-form'
export const API_ROUTES_GRAPHQL = '/api/v1/rgs/graphql'
export const API_ROUTES_SEND_CAREER_FORM = '/api/v1/rgs/form/career-form'
export const API_ROUTES_ALL_OFFICES = '/api/v1/rgs/offices'

export const API_ROUTES_SPRUT_PRODUCTS = '/api/v1/rgs/sprut/products'
export const API_ROUTES_SPRUT_CALCULATE = '/api/v1/rgs/sprut/calculate'
export const API_ROUTES_SPRUT_CONTRACT_INIT = '/api/v1/rgs/sprut/contract/init'

export const API_ROUTES_SEND_MC_ORM_EVENT = '/api/v1/rgs/ms-orm/send-event'

export const API_ACTIVATE_CERTIFICATE_WB = '/api/v1/rgs/appeal/wb-form'

export const API_SEND_APPEAL_BUY_BY_TEL_REGION =
  '/api/v1/rgs/appeal/buy-by-tel-region'
